var E = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), d = new RegExp(/(\"|in|inch|inches)/), N = new RegExp(/^(\s{0,})(-{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), $ = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\'|ft|feet)(\s{0,})$/), u = new RegExp(/(\'|ft|feet)/), b = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*((\s{0,})|(\s{0,1})(\"|in|inch|inches)(\s{0,}))$/), B = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*(\s{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), y = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})$/), D = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})$/), w = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(m|meter|meters)(\s{0,})$/), x = new RegExp(/(m|meter|meters)/), R = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})((cm)|(centimeter)|(centimeters))(\s{0,})$/), L = new RegExp(/(cm|centimeter|centimeters)/), M = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(mm|millimeter|millimeters)(\s{0,})$/), T = new RegExp(/(mm|millimeter|millimeters)/);
function c(e) {
  var r = e.split(d);
  if (r.length <= 0 || isNaN(r[0]))
    throw "Error Parsing Inches: " + e;
  return Number(r[0]);
}
function m(e) {
  var r = e.split(d);
  if (r.length > 0 && (r = r[0].split(/\//), r.length > 1)) {
    var t = r[0], n = c(r[1]);
    if (!isNaN(t) && !isNaN(n))
      return Number(t) / Number(n);
  }
  throw "Error Parsing Inch Fraction: " + e;
}
function C(e) {
  var r = e.split(u);
  if (r.length <= 0 || isNaN(r[0]))
    throw "Error Parsing Feet: " + e;
  return Number(r[0] * 12);
}
function a(e, r) {
  if (e = e.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'), e.match(y) || e.match(D))
    return Number(e) * 12;
  if (e.match(E))
    return c(e);
  if (e.match(N))
    return m(e);
  if (e.match($))
    return C(e);
  if (e.match(b)) {
    var t = e.split(u);
    try {
      var n = Number(t[0]), i = c(t[2]);
      return n * 12 + i;
    } catch (s) {
      return console.log(s), 0;
    }
  }
  if (e.match(B)) {
    const s = e.split(u), f = Number(s[0]);
    let l = s[2].split(" ");
    l.length < 3 && l.unshift(" ");
    const h = Number(l[1]) || 0, g = m(l[2]);
    return f * 12 + h + g;
  }
  if (e.match(w)) {
    var t = e.split(x), o = Number(t[0]);
    return Math.round(o * 39.370078 * 1e4) / 1e4;
  }
  if (e.match(R)) {
    var t = e.split(L), v = Number(t[0]);
    return v * 0.39370078;
  }
  if (e.match(M)) {
    var t = e.split(T), p = Number(t[0]);
    return p * 0.039370078;
  }
  return NaN;
}
function F(e) {
  const r = document.getElementById(e);
  if (r.value !== null && r.value.trim() !== "") {
    const t = document.getElementById(`${e}-error`);
    return t && t.remove(), !0;
  } else {
    const t = document.createElement("div");
    return t.id = `${e}-error`, t.innerHTML = "This field is required.", r.parentElement.appendChild(t), !1;
  }
}
function H(e) {
  const r = document.getElementById(e);
  if (isNaN(a(r.value))) {
    const t = document.createElement("div");
    return t.id = `${e}-error`, t.innerHTML = 'Please enter a valid length unit. For example <code>5 in</code>, <code>5 inches</code> or <code>5"</code>', r.parentElement.appendChild(t), !1;
  } else {
    const t = document.getElementById(`${e}-error`);
    return t && t.remove(), !0;
  }
}
function P(e, r) {
  const t = document.getElementById(e);
  if (!isNaN(parseFloat(t.value)) && parseFloat(t.value) >= r) {
    const n = document.getElementById(`${e}-error`);
    return n && n.remove(), !0;
  } else {
    const n = document.createElement("div");
    return n.id = `${e}-error`, n.innerHTML = `Number must be greater than or equal to ${r}`, t.parentElement.appendChild(n), !1;
  }
}
function q(e, r) {
  const t = document.getElementById(e);
  if (!isNaN(parseFloat(t.value)) && parseFloat(t.value) > r) {
    const n = document.getElementById(`${e}-error`);
    return n && n.remove(), !0;
  } else {
    const n = document.createElement("div");
    return n.id = `${e}-error`, n.innerHTML = `Number must be greater than to ${r}`, t.parentElement.appendChild(n), !1;
  }
}
function I(e, r) {
  const t = document.getElementById(e), n = a(t.value);
  if (!isNaN(n) && n >= 0 && n <= r) {
    const i = document.getElementById(`${e}-error`);
    return i && i.remove(), !0;
  } else {
    const i = document.createElement("div");
    return i.id = `${e}-error`, i.innerHTML = "Position must be on the beam.", t.parentElement.appendChild(i), !1;
  }
}
function S(e, r) {
  const t = document.getElementById(e), n = t.value, i = a(n);
  if (!isNaN(i) && i > 0 && i <= r) {
    const o = document.getElementById(`${e}-error`);
    return o && o.remove(), !0;
  } else {
    const o = document.createElement("div");
    return o.id = `${e}-error`, o.innerHTML = "Brace spacing must be larger than 0 and less than or equal to the total length of the beam.", t.parentElement.appendChild(o), !1;
  }
}
function k(e, r) {
  const t = document.getElementById(e), n = t.value, i = a(n);
  if (!isNaN(i) && i >= 0 && i <= r) {
    const o = document.getElementById(`${e}-error`);
    return o && o.remove(), !0;
  } else {
    const o = document.createElement("div");
    return o.id = `${e}-error`, o.innerHTML = "Brace location must be greater than or equal to 0 and less than or equal to the total length of the beam.", t.parentElement.appendChild(o), !1;
  }
}
function G(e, r) {
  const t = a(document.getElementById(e).value), n = a(document.getElementById(r).value);
  if (t < n) {
    const i = document.getElementById(`${r}-error`);
    return i && i.remove(), !0;
  } else {
    let i = document.getElementById(`${r}-error`);
    return i === null && (i = document.createElement("div"), i.id = `${r}-error`, document.getElementById(r).parentElement.appendChild(i)), i.innerHTML = "Start position must be less than end position.", !1;
  }
}
function K(e) {
  const r = document.getElementById(e);
  if (!isNaN(parseFloat(r.value)) && isFinite(r.value)) {
    const t = document.getElementById(`${e}-error`);
    return t && t.remove(), !0;
  } else {
    const t = document.createElement("div");
    return t.id = `${e}-error`, t.innerHTML = "Must be a number and must be finite.", r.parentElement.appendChild(t), !1;
  }
}
export {
  k as validateBraceLocation,
  S as validateBraceSpacing,
  G as validateDistributedLoadPosition,
  q as validateGreaterThan,
  H as validateLengthInput,
  K as validateLoadMagnitude,
  I as validateLocation,
  P as validateMinimum,
  F as validateRequiredInput
};
